module.exports = __webpack_public_path__ + "img/loupe.0b5fb4e1.svg";